import { render, staticRenderFns } from "./ListingAssignItem.vue?vue&type=template&id=6916d4f6&scoped=true&lang=pug&"
import script from "./ListingAssignItem.vue?vue&type=script&lang=js&"
export * from "./ListingAssignItem.vue?vue&type=script&lang=js&"
import style0 from "./ListingAssignItem.vue?vue&type=style&index=0&id=6916d4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916d4f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VIcon})
